// extracted by mini-css-extract-plugin
export default {"loader":"PlaybookModalContent_loader__1V5GA"};